import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router';
import { WithPageViewModes } from '../../components/WithPageViewModes';
import { ROUTE_VIEW_MODE, VIEW_MODE } from '../../consts/enums';
import { PERMISSIONS } from '../../consts/permissions';
import { useAuth } from '../../hooks/useAuth';
import { useGetTalent } from '../../hooks/useTalent';
import TalentsEdit from '../TalentsPage/TalentsEdit';
import { talentEditPageStyle } from './style';

type TalentEditPageProps = {
  viewMode: ViewMode,
};

const TalentEditPageComponent = ({
  viewMode,
}: TalentEditPageProps):JSX.Element => {
  const params = useParams();
  const { hasPermissions } = useAuth();

  const currentTalentId = params.talentId || '';
  
  const { isLoading, data } = useGetTalent(currentTalentId);

  if (isLoading) {
    return (
      <Box style={ talentEditPageStyle.box }>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TalentsEdit
      data={ data }
      isShowUpdateContactInfo={ hasPermissions([PERMISSIONS.TALENT_CONTACT_DETAILS_EDIT]) }
      viewMode={ viewMode }
    />
  );
};

export const TalentEditPage = WithPageViewModes(TalentEditPageComponent, [
  {
    routeParam: ROUTE_VIEW_MODE.VIEW,
    viewMode: VIEW_MODE.READ_ONLY,
    permissions: [PERMISSIONS.TALENT_VIEW],
  },
  {
    routeParam: ROUTE_VIEW_MODE.EDIT,
    viewMode: VIEW_MODE.EDITABLE,
    permissions: [PERMISSIONS.TALENT_EDIT],
  },
]);
